export default __webpack_public_path__ + "static/media/DNo.32-3.5d94847d.jpg";